module.exports = __webpack_public_path__ + "media/src/images/icon__sad--3-f8882dea3e8a93932f97c0c54f30666b.png";